import { nip04, nip44, own, hash, sign, getPubkey, makeSecret } from "../util.js";
export class Nip01Signer {
    secret;
    #pubkey;
    constructor(secret) {
        this.secret = secret;
        this.#pubkey = getPubkey(this.secret);
    }
    static fromSecret = (secret) => new Nip01Signer(secret);
    static ephemeral = () => new Nip01Signer(makeSecret());
    getPubkey = async () => this.#pubkey;
    sign = async (event) => sign(hash(own(event, this.#pubkey)), this.secret);
    nip04 = {
        encrypt: async (pubkey, message) => nip04.encrypt(pubkey, this.secret, message),
        decrypt: async (pubkey, message) => nip04.decrypt(pubkey, this.secret, message),
    };
    nip44 = {
        encrypt: async (pubkey, message) => nip44.encrypt(pubkey, this.secret, message),
        decrypt: async (pubkey, message) => nip44.decrypt(pubkey, this.secret, message),
    };
}
//# sourceMappingURL=nip01.js.map